export const PENSION_HERO_ID = 'pension-hero'
export const PENSION_REGISTER_PAYMENT_ID = 'pension-register-payment'

/**
 * Scroll the dashboard pension hero into view.
 * Optionally move keyboard focus to "Registrar pago" when that button exists.
 */
export const scrollToPensionHero = ({ focusPayment = false } = {}) => {
  const hero = document.getElementById(PENSION_HERO_ID)
  if (hero) {
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
    hero.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start',
    })
  }

  if (!focusPayment) return

  const focusTarget = () => {
    document.getElementById(PENSION_REGISTER_PAYMENT_ID)?.focus()
  }

  window.requestAnimationFrame(focusTarget)
}
